// extracted by mini-css-extract-plugin
export default {"external":"aTIVRP","paymentType":"bTIVRP","label":"cTIVRP","banner":"dTIVRP","cells":"eTIVRP"};